import { SVGAttributes } from 'react';

type InternalProps = SVGAttributes<SVGSVGElement>;

const UserIcon = (props: InternalProps) => (
  <svg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M17.63 15.217a7.822 7.822 0 0 0-1.787-2.502 8.37 8.37 0 0 0-2.649-1.687c-.009-.005-.017-.007-.026-.01 1.38-.943 2.278-2.478 2.278-4.21 0-2.868-2.46-5.192-5.496-5.192-3.037 0-5.497 2.324-5.497 5.193 0 1.731.898 3.266 2.279 4.21-.01.005-.018.007-.027.01a8.298 8.298 0 0 0-2.648 1.688A7.858 7.858 0 0 0 2.27 15.22a7.418 7.418 0 0 0-.654 2.892.16.16 0 0 0 .05.121.178.178 0 0 0 .128.05h1.33a.173.173 0 0 0 .177-.163c.044-1.616.731-3.13 1.946-4.277 1.256-1.187 2.925-1.84 4.703-1.84 1.777 0 3.446.653 4.703 1.84 1.214 1.147 1.901 2.661 1.946 4.277.002.093.08.164.177.164h1.33a.186.186 0 0 0 .127-.05.166.166 0 0 0 .05-.122 7.434 7.434 0 0 0-.654-2.894ZM9.95 10.41a3.902 3.902 0 0 1-2.695-1.055 3.48 3.48 0 0 1-1.117-2.546 3.48 3.48 0 0 1 1.117-2.546A3.902 3.902 0 0 1 9.95 3.207c1.017 0 1.974.375 2.695 1.056a3.48 3.48 0 0 1 1.117 2.546 3.48 3.48 0 0 1-1.117 2.546A3.902 3.902 0 0 1 9.95 10.41Z' />
  </svg>
);

const CloseIcon = (props: InternalProps) => (
  <svg width='16' height='16' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='m8.001 8 6.991 6.99m-13.981 0L8 8l-6.99 6.99ZM14.992 1.01 8 8l6.992-6.99ZM8 8 1.01 1.01 8 8Z'
      stroke='#444'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const LineIcon = (props: InternalProps) => (
  <svg width='40' height='40' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M31.494 5.907c-1.298 0-2.35.96-2.35 2.145v5.147c0 .84.53 1.568 1.302 1.92.263-.126.564-.197.884-.197.379 0 .732.1 1.027.272.872-.314 1.488-1.089 1.488-1.995V8.052c0-1.185-1.052-2.145-2.35-2.145Zm-5.172 7.292c0 1.94 1.284 3.607 3.12 4.332v9.24c0 .898-.398 1.759-1.107 2.394-.708.635-1.668.991-2.67.991s-1.962-.356-2.67-.991c-.709-.635-1.107-1.496-1.107-2.394V13.229c0-1.795-.796-3.518-2.212-4.787-1.417-1.27-3.338-1.984-5.341-1.984s-3.925.714-5.341 1.984c-1.417 1.27-2.212 2.992-2.212 4.787v9.123c-2.01.648-3.449 2.395-3.449 4.45v5.147c0 2.605 2.316 4.718 5.173 4.718 2.856 0 5.172-2.113 5.172-4.718V26.8c0-1.94-1.284-3.607-3.12-4.332v-9.24c0-.898.398-1.759 1.106-2.394.709-.635 1.67-.991 2.67-.991 1.002 0 1.963.357 2.671.991.709.635 1.107 1.496 1.107 2.394v13.542c0 1.796.795 3.518 2.212 4.788 1.416 1.27 3.338 1.983 5.341 1.983s3.925-.714 5.341-1.983c1.416-1.27 2.212-2.992 2.212-4.788v-9.123c2.01-.647 3.449-2.395 3.449-4.45V8.053c0-2.606-2.316-4.719-5.173-4.719-2.856 0-5.172 2.113-5.172 4.719v5.147ZM7.642 24.806c.296.172.65.272 1.028.272.32 0 .62-.071.884-.197.772.352 1.303 1.08 1.303 1.92v5.148c0 1.184-1.053 2.144-2.351 2.144-1.299 0-2.351-.96-2.351-2.144V26.8c0-.906.616-1.681 1.488-1.995Z'
    />
  </svg>
);
const TalkIcon = (props: InternalProps) => (
  <svg width='40' height='40' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.873 5h17.763a3.148 3.148 0 0 1 2.15.945c.565.58.881 1.355.88 2.16v18.552a1.029 1.029 0 0 1-.595.931 1.054 1.054 0 0 1-1.045-.114l-4.995-3.84H15.873a3.15 3.15 0 0 1-2.217-.91 3.091 3.091 0 0 1-.918-2.196V8.106c0-.824.33-1.614.918-2.196A3.15 3.15 0 0 1 15.872 5Zm-6.27 7.247v8.281c0 1.648.66 3.228 1.836 4.392a6.3 6.3 0 0 0 4.434 1.82h11.494v1.17a2.843 2.843 0 0 1-.839 2.125 2.896 2.896 0 0 1-2.14.846H10.346l-5.382 3.923a1.05 1.05 0 0 1-1.044.103 1.041 1.041 0 0 1-.586-.92V15.351c0-.823.33-1.613.918-2.196a3.15 3.15 0 0 1 2.217-.91h3.135Z'
    />
  </svg>
);
const TrainingIcon = (props: InternalProps) => (
  <svg width='40' height='40' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M14.167 25c-.125 0-.25.018-.368.057a6.87 6.87 0 0 1-2.132.36c-.748 0-1.458-.141-2.133-.36A1.19 1.19 0 0 0 9.167 25a5.834 5.834 0 0 0-5.834 5.866c.008 1.367 1.132 2.467 2.5 2.467H17.5c1.368 0 2.493-1.1 2.5-2.467A5.834 5.834 0 0 0 14.167 25Zm-2.5-1.667a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm22.5-16.666h-20c-1.379 0-2.5 1.158-2.5 2.582v2.418c1.22 0 2.349.353 3.333.927V10h18.333v15H30v-3.333h-6.667V25h-3.97a6.638 6.638 0 0 1 2.067 3.333h12.737c1.378 0 2.5-1.159 2.5-2.582V9.248c0-1.424-1.122-2.582-2.5-2.582Z' />
  </svg>
);
const VesselIcon = (props: InternalProps) => (
  <svg width='34' height='34' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M12.238 1.722c0-.368.126-.721.349-.982.223-.26.526-.407.842-.407h7.142c.316 0 .619.147.842.407.224.26.349.614.349.982V5.89h5.952c.316 0 .619.146.842.407.223.26.349.613.349.982v9.783l2.854 1.445c.152.077.289.19.401.332.112.143.198.31.251.494a1.608 1.608 0 0 1-.085 1.118L29.6 26.175c-.369-.786-.833-1.603-1.774-1.994l1.781-3.74-11.188-5.655A3.14 3.14 0 0 0 17 14.443a3.14 3.14 0 0 0-1.419.343L4.393 20.445l1.78 3.738c-.937.392-1.404 1.209-1.773 1.995l-2.726-5.722a1.607 1.607 0 0 1-.09-1.124c.052-.185.138-.354.25-.498.114-.143.251-.257.404-.334l2.857-1.442v-9.78c0-.369.126-.722.349-.982.223-.26.526-.407.842-.407h5.952V1.722ZM7.476 15.856l7.157-3.617A5.235 5.235 0 0 1 17 11.666c.814 0 1.62.195 2.367.573l7.157 3.617v-7.19H7.476v7.19ZM19.381 3.11h-4.762V5.89h4.762V3.11ZM6.529 27.272c-.03.045-.057.091-.081.14a3.308 3.308 0 0 0-.143.352 3.64 3.64 0 0 1-.129.325c-.199.412-.446.79-.733 1.122-.681.8-1.872 1.678-3.92 1.678-.315 0-.618.146-.841.407-.223.26-.349.614-.349.982s.126.721.349.982c.223.26.526.407.842.407 2.716 0 4.502-1.206 5.605-2.49.102-.121.2-.24.29-.36.06.086.12.177.183.266.898 1.256 2.398 2.584 4.636 2.584s3.738-1.328 4.636-2.584L17 30.9l.126.183c.898 1.256 2.398 2.584 4.636 2.584s3.738-1.328 4.636-2.584c.064-.088.123-.18.183-.27.09.12.188.243.29.362 1.103 1.286 2.889 2.492 5.605 2.492.316 0 .619-.147.842-.407.223-.26.349-.614.349-.982s-.126-.722-.349-.982a1.112 1.112 0 0 0-.842-.407c-2.045 0-3.235-.878-3.919-1.678a4.954 4.954 0 0 1-.905-1.544 1.393 1.393 0 0 0-.435-.679 1.08 1.08 0 0 0-.692-.258c-.248 0-.49.09-.692.258a1.394 1.394 0 0 0-.435.679c-.201.593-.48 1.146-.829 1.639-.593.827-1.476 1.583-2.81 1.583-1.33 0-2.214-.756-2.804-1.583a6.392 6.392 0 0 1-.824-1.625c-.05-.18-.13-.348-.238-.49a1.221 1.221 0 0 0-.385-.339 1.034 1.034 0 0 0-.944-.033 1.19 1.19 0 0 0-.432.34c-.12.148-.211.327-.265.522a6.397 6.397 0 0 1-.824 1.625c-.59.827-1.472 1.583-2.805 1.583-1.333 0-2.214-.756-2.805-1.583a6.29 6.29 0 0 1-.65-1.167 4.37 4.37 0 0 1-.119-.314c-.047-.139-.095-.283-.16-.411a1.25 1.25 0 0 0-.652-.62l-.012-.005a1.023 1.023 0 0 0-.722-.004 1.205 1.205 0 0 0-.59.487Z' />
  </svg>
);
const SettingIcon = (props: InternalProps) => (
  <svg width='20' height='20' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M9.586 7.73c-.558 0-1.081.217-1.477.612a2.071 2.071 0 0 0-.613 1.473c0 .557.218 1.079.613 1.474.396.393.919.61 1.477.61.559 0 1.082-.217 1.478-.61.395-.395.613-.917.613-1.474 0-.557-.218-1.078-.613-1.473a2.073 2.073 0 0 0-1.478-.611Zm7.704 4.387-1.222-1.04a6.664 6.664 0 0 0 0-2.15l1.221-1.042a.596.596 0 0 0 .174-.655l-.017-.049a8.238 8.238 0 0 0-1.487-2.565l-.033-.039a.6.6 0 0 0-.656-.177l-1.517.539a6.528 6.528 0 0 0-1.861-1.072l-.293-1.581a.596.596 0 0 0-.482-.479l-.05-.01a8.444 8.444 0 0 0-2.968.001l-.05.01a.6.6 0 0 0-.482.478l-.295 1.589a6.608 6.608 0 0 0-1.848 1.067L3.895 4.4a.6.6 0 0 0-.655.177l-.034.04A8.3 8.3 0 0 0 1.719 7.18l-.017.049a.597.597 0 0 0 .174.655l1.237 1.053a6.529 6.529 0 0 0 0 2.123L1.88 12.114a.596.596 0 0 0-.174.655l.017.049a8.257 8.257 0 0 0 1.487 2.565l.033.04a.6.6 0 0 0 .656.176l1.528-.542a6.476 6.476 0 0 0 1.848 1.067l.295 1.59a.596.596 0 0 0 .482.478l.05.01a8.402 8.402 0 0 0 2.968 0l.05-.01a.6.6 0 0 0 .482-.479l.294-1.581a6.576 6.576 0 0 0 1.86-1.071l1.518.538a.6.6 0 0 0 .655-.177l.034-.04a8.3 8.3 0 0 0 1.487-2.564l.017-.048a.6.6 0 0 0-.177-.652Zm-7.704.973a3.28 3.28 0 0 1-3.284-3.275A3.28 3.28 0 0 1 9.586 6.54a3.28 3.28 0 0 1 3.285 3.275 3.28 3.28 0 0 1-3.285 3.275Z' />
  </svg>
);
const LoadingIcon = (props: InternalProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' stroke='#fff' viewBox='0 0 38 38' width='38' height='38' {...props}>
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(1 1)' strokeWidth='2'>
        <circle strokeOpacity='.5' cx='18' cy='18' r='18'></circle>
        <path d='M36 18c0-9.94-8.06-18-18-18'>
          <animateTransform
            attributeName='transform'
            type='rotate'
            from='0 18 18'
            to='360 18 18'
            dur='1s'
            repeatCount='indefinite'
          ></animateTransform>
        </path>
      </g>
    </g>
  </svg>
);
const UploadFileIcon = (props: InternalProps) => (
  <svg width='20' height='18' viewBox='0 0 20 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M9.48128 4.71995V4.21995H8.98128H7.52754L9.99992 0.720082L12.4705 4.21995H11.0134H10.5134V4.71995V11.5167H9.48128V4.71995ZM17.9679 16.2263H18.4679V15.7263V11.3798H19.5V17.0427C19.5 17.3503 19.2902 17.5 19.1444 17.5H0.855615C0.709831 17.5 0.5 17.3503 0.5 17.0427V11.3798H1.53209V15.7263V16.2263H2.03209H17.9679Z'
      fill='#808080'
      stroke='#808080'
    />
  </svg>
);
const AttachFileIcon = (props: InternalProps) => (
  <svg width='13' height='13' viewBox='0 0 13 13' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M10.9452 1.09812C9.27298 -0.366039 6.5499 -0.366039 4.87949 1.09812L0.246366 5.15174C0.216188 5.17816 0.200212 5.21391 0.200212 5.25121C0.200212 5.28852 0.216188 5.32427 0.246366 5.35069L0.901394 5.92423C0.931335 5.95033 0.971865 5.96498 1.01412 5.96498C1.05637 5.96498 1.0969 5.95033 1.12684 5.92423L5.75997 1.8706C6.33511 1.36701 7.1002 1.09034 7.91322 1.09034C8.72623 1.09034 9.49132 1.36701 10.0647 1.8706C10.6398 2.3742 10.9558 3.0441 10.9558 3.75442C10.9558 4.46629 10.6398 5.13464 10.0647 5.63824L5.34281 9.77113L4.57772 10.441C3.86234 11.0674 2.69962 11.0674 1.98423 10.441C1.63808 10.1379 1.44814 9.73538 1.44814 9.30639C1.44814 8.8774 1.63808 8.47484 1.98423 8.17175L6.66884 4.0715C6.78777 3.96891 6.94399 3.9114 7.11085 3.9114H7.11263C7.27949 3.9114 7.43393 3.96891 7.55109 4.0715C7.67002 4.17564 7.73393 4.31241 7.73393 4.45852C7.73393 4.60307 7.66825 4.73985 7.55109 4.84243L3.7221 8.19196C3.69192 8.21838 3.67595 8.25413 3.67595 8.29143C3.67595 8.32874 3.69192 8.36448 3.7221 8.39091L4.37713 8.96445C4.40707 8.99055 4.4476 9.0052 4.48985 9.0052C4.5321 9.0052 4.57263 8.99055 4.60257 8.96445L8.42978 5.61337C8.78304 5.30406 8.97653 4.89372 8.97653 4.45697C8.97653 4.02021 8.78126 3.60832 8.42978 3.30056C7.7002 2.66174 6.5144 2.6633 5.78482 3.30056L5.33038 3.70002L1.10199 7.40082C0.814999 7.65062 0.58751 7.94784 0.432712 8.27521C0.277913 8.60259 0.198886 8.95362 0.200212 9.30795C0.200212 10.0276 0.521513 10.7037 1.10199 11.212C1.70376 11.7373 2.49192 12 3.28009 12C4.06825 12 4.85642 11.7373 5.45642 11.212L10.9452 6.40917C11.7529 5.70041 12.2002 4.75695 12.2002 3.75442C12.202 2.75034 11.7546 1.80688 10.9452 1.09812Z'
      fill='white'
    />
  </svg>
);
const FinderIcon = (props: InternalProps) => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8.64901 16.6312C10.4201 16.6308 12.1401 16.0379 13.5352 14.9469L17.9215 19.3332L19.3324 17.9223L14.9461 13.536C16.0377 12.1408 16.6309 10.4203 16.6313 8.64883C16.6313 4.24758 13.0503 0.666504 8.64901 0.666504C4.24776 0.666504 0.666687 4.24758 0.666687 8.64883C0.666687 13.0501 4.24776 16.6312 8.64901 16.6312ZM8.64901 2.66209C11.9507 2.66209 14.6358 5.34714 14.6358 8.64883C14.6358 11.9505 11.9507 14.6356 8.64901 14.6356C5.34732 14.6356 2.66227 11.9505 2.66227 8.64883C2.66227 5.34714 5.34732 2.66209 8.64901 2.66209Z'
      fill='black'
    />
  </svg>
);
const ExportIcon = (props: InternalProps) => (
  <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.5858 2.3038H12.9882V0.51355L0.5 2.44105V19.3363L12.9882 21.4873V18.8338H20.5858C20.8158 18.8455 21.0412 18.7655 21.2125 18.6115C21.3839 18.4574 21.4872 18.2418 21.5 18.0118V3.12505C21.487 2.89515 21.3836 2.67972 21.2123 2.52585C21.041 2.37197 20.8157 2.29214 20.5858 2.3038ZM20.7057 18.1483H12.9628L12.95 16.7315H14.8153V15.0815H12.9357L12.9268 14.1065H14.8153V12.4565H12.9125L12.9035 11.4815H14.8153V9.83155H12.8975V8.85655H14.8153V7.20655H12.8975V6.23155H14.8153V4.58155H12.8975V3.08155H20.7057V18.1483Z'
      fill='#20744A'
    />
    <path
      d='M15.8652 4.57935H19.1075V6.22935H15.8652V4.57935ZM15.8652 7.2051H19.1075V8.8551H15.8652V7.2051ZM15.8652 9.83085H19.1075V11.4808H15.8652V9.83085ZM15.8652 12.4566H19.1075V14.1066H15.8652V12.4566ZM15.8652 15.0823H19.1075V16.7323H15.8652V15.0823Z'
      fill='#20744A'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.76025 7.00482L5.36975 6.91257L6.3815 9.69432L7.577 6.79782L9.1865 6.70557L7.232 10.6551L9.1865 14.6143L7.48475 14.4996L6.33575 11.4816L5.186 14.3848L3.62225 14.2468L5.43875 10.7496L3.76025 7.00482Z'
      fill='white'
    />
  </svg>
);
const AnchorIcon = (props: InternalProps) => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M17.3333 11.5L14.8333 8.16666L12.3333 11.5H13.9216C13.5583 13.5575 11.89 15.2258 9.83329 15.5883V9.83332H11.5V8.16666H9.83329V6.77999C11.1191 6.39749 12.095 5.17749 12.095 3.76249C12.095 2.05499 10.7066 0.666656 8.99996 0.666656C7.29329 0.666656 5.90496 2.05499 5.90496 3.76249C5.90496 5.17749 6.88079 6.39749 8.16663 6.77999V8.16666H6.49996V9.83332H8.16663V15.5883C6.10913 15.2258 4.44079 13.5575 4.07829 11.5H5.66663L3.16663 8.16666L0.666626 11.5H2.39413C2.81996 14.7375 5.66829 17.3333 8.99996 17.3333C12.3316 17.3333 15.18 14.7375 15.6058 11.5H17.3333ZM7.57163 3.76249C7.57163 2.97499 8.21246 2.33332 8.99996 2.33332C9.78746 2.33332 10.4283 2.97499 10.4283 3.76249C10.4283 4.55499 9.76079 5.24999 8.99996 5.24999C8.23913 5.24999 7.57163 4.55499 7.57163 3.76249Z'
      fill='white'
    />
  </svg>
);
const CheckboxIcon = (props: InternalProps) => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M18.3333 0H1.66667C1.22464 0 0.800716 0.175595 0.488155 0.488155C0.175595 0.800716 0 1.22464 0 1.66667V18.3333C0 18.7754 0.175595 19.1993 0.488155 19.5118C0.800716 19.8244 1.22464 20 1.66667 20H18.3333C18.7754 20 19.1993 19.8244 19.5118 19.5118C19.8244 19.1993 20 18.7754 20 18.3333V1.66667C20 1.22464 19.8244 0.800716 19.5118 0.488155C19.1993 0.175595 18.7754 0 18.3333 0ZM8.33333 14.5833L4.16667 10.4525L5.49167 9.16667L8.33333 11.955L14.5075 5.83333L15.8333 7.1475L8.33333 14.5833Z' />
  </svg>
);
const RemoveIcon = (props: InternalProps) => (
  <svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M14 0.666504C6.64 0.666504 0.666667 6.63984 0.666667 13.9998C0.666667 21.3598 6.64 27.3332 14 27.3332C21.36 27.3332 27.3333 21.3598 27.3333 13.9998C27.3333 6.63984 21.36 0.666504 14 0.666504ZM20.6667 15.3332H7.33333V12.6665H20.6667V15.3332Z'
      fill='#CD0202'
    />
  </svg>
);
const MinusIcon = (props: InternalProps) => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill='#F8F8F8' />
    <path d='M22.6668 16H9.3335' stroke='#444444' stroke-width='2' stroke-linecap='round' />
  </svg>
);
const PlusIcon = (props: InternalProps) => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill='#E8F1FF' />
    <path
      d='M16.0002 22.6667V16M16.0002 16V9.33337M16.0002 16H22.6668M16.0002 16H9.3335'
      stroke='#0C1B6E'
      strokeOpacity='0.8'
      strokeWidth='2'
      strokeLinecap='round'
    />
  </svg>
);
const CircleChevronRightIcon = (props: InternalProps) => (
  <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8 15.5C11.866 15.5 15 12.366 15 8.5C15 4.63401 11.866 1.5 8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 12.366 4.13401 15.5 8 15.5Z'
      stroke='#444444'
    />
    <path
      d='M7.2998 5.69995L10.0998 8.49995L7.2998 11.3'
      stroke='#444444'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const ArrowBackIcon = (props: InternalProps) => (
  <svg width='10' height='16' viewBox='0 0 10 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M8.65828 1.5835L1.90723 8.25016L8.65828 14.9168'
      stroke='black'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const UserPlusIcon = (props: InternalProps) => (
  <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <circle cx='20' cy='20' r='20' fill='#E8F1FF' />
    <path
      d='M23.6868 22.6891C24.254 22.3844 24.9032 22.2109 25.5946 22.2109H25.5969C25.6672 22.2109 25.7001 22.1266 25.6485 22.0797C24.9295 21.4344 24.1081 20.9132 23.218 20.5375C23.2087 20.5328 23.1993 20.5305 23.1899 20.5258C24.6454 19.4687 25.5922 17.7508 25.5922 15.8125C25.5922 12.6016 22.9954 10 19.7915 10C16.5876 10 13.993 12.6016 13.993 15.8125C13.993 17.7508 14.9399 19.4687 16.3977 20.5258C16.3883 20.5305 16.379 20.5328 16.3696 20.5375C15.3219 20.9805 14.3821 21.6156 13.5735 22.4266C12.7696 23.229 12.1295 24.1803 11.6891 25.2273C11.2558 26.2526 11.0219 27.3512 11.0001 28.4641C10.9994 28.4891 11.0038 28.514 11.013 28.5373C11.0221 28.5605 11.0358 28.5818 11.0533 28.5997C11.0708 28.6176 11.0916 28.6318 11.1147 28.6415C11.1378 28.6513 11.1625 28.6563 11.1876 28.6562H12.5915C12.6922 28.6562 12.7766 28.5742 12.779 28.4734C12.8258 26.6641 13.5501 24.9695 14.8321 23.6852C16.1563 22.3563 17.9188 21.625 19.7938 21.625C21.1227 21.625 22.3977 21.993 23.4969 22.682C23.5252 22.6998 23.5576 22.7098 23.5909 22.711C23.6242 22.7122 23.6573 22.7047 23.6868 22.6891V22.6891ZM19.7938 19.8438C18.7204 19.8438 17.7102 19.4242 16.9485 18.6625C16.5737 18.2887 16.2766 17.8444 16.0743 17.3553C15.8719 16.8662 15.7684 16.3418 15.7696 15.8125C15.7696 14.7367 16.1891 13.7242 16.9485 12.9625C17.7079 12.2008 18.718 11.7812 19.7938 11.7812C20.8696 11.7812 21.8774 12.2008 22.6391 12.9625C23.0139 13.3363 23.311 13.7806 23.5133 14.2697C23.7157 14.7588 23.8192 15.2832 23.818 15.8125C23.818 16.8883 23.3985 17.9008 22.6391 18.6625C21.8774 19.4242 20.8672 19.8438 19.7938 19.8438ZM28.4141 25.4219H26.4454V23.4531C26.4454 23.35 26.361 23.2656 26.2579 23.2656H24.9454C24.8422 23.2656 24.7579 23.35 24.7579 23.4531V25.4219H22.7891C22.686 25.4219 22.6016 25.5062 22.6016 25.6094V26.9219C22.6016 27.025 22.686 27.1094 22.7891 27.1094H24.7579V29.0781C24.7579 29.1813 24.8422 29.2656 24.9454 29.2656H26.2579C26.361 29.2656 26.4454 29.1813 26.4454 29.0781V27.1094H28.4141C28.5172 27.1094 28.6016 27.025 28.6016 26.9219V25.6094C28.6016 25.5062 28.5172 25.4219 28.4141 25.4219Z'
      fill='#0C1B6E'
    />
  </svg>
);
const ArrowDownIcon = (props: InternalProps) => (
  <svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M4 6H11L7.5 10.5L4 6Z' fill='currentColor' />
  </svg>
);
const ArrowUpIcon = (props: InternalProps) => (
  <svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M4 9H11L7.5 4.5L4 9Z' fill='currentColor' />
  </svg>
);

export type IconVariant =
  | 'user'
  | 'close'
  | 'line'
  | 'talk'
  | 'training'
  | 'vessel'
  | 'setting'
  | 'loading'
  | 'uploadFile'
  | 'attachFile'
  | 'finder'
  | 'excel'
  | 'anchor'
  | 'checkbox'
  | 'remove'
  | 'minus'
  | 'plus'
  | 'circleChevronRight'
  | 'arrowBack'
  | 'userPlus'
  | 'arrowUp'
  | 'arrowDown';
export type IconProps = InternalProps & {
  variant: IconVariant;
};
export const Icon = ({ variant, ...props }: IconProps) => {
  switch (variant) {
    case 'user':
      return <UserIcon {...props} />;
    case 'close':
      return <CloseIcon {...props} />;
    case 'line':
      return <LineIcon {...props} />;
    case 'talk':
      return <TalkIcon {...props} />;
    case 'training':
      return <TrainingIcon {...props} />;
    case 'vessel':
      return <VesselIcon {...props} />;
    case 'setting':
      return <SettingIcon {...props} />;
    case 'loading':
      return <LoadingIcon {...props} />;
    case 'uploadFile':
      return <UploadFileIcon {...props} />;
    case 'attachFile':
      return <AttachFileIcon {...props} />;
    case 'finder':
      return <FinderIcon {...props} />;
    case 'excel':
      return <ExportIcon {...props} />;
    case 'anchor':
      return <AnchorIcon {...props} />;
    case 'checkbox':
      return <CheckboxIcon {...props} />;
    case 'remove':
      return <RemoveIcon {...props} />;
    case 'minus':
      return <MinusIcon {...props} />;
    case 'plus':
      return <PlusIcon {...props} />;
    case 'circleChevronRight':
      return <CircleChevronRightIcon {...props} />;
    case 'arrowBack':
      return <ArrowBackIcon {...props} />;
    case 'userPlus':
      return <UserPlusIcon {...props} />;
    case 'arrowUp':
      return <ArrowUpIcon {...props} />;
    case 'arrowDown':
      return <ArrowDownIcon {...props} />;
    default:
      return <div />;
  }
};
